export enum TEACHER_COMMON_MENU_ITEMS {
    LIBRARY = 'library',
    MY_LESSONS = 'my_lessons',
    JOURNAL = 'journal',
    OLYMPIAD = 'olympiad',
    EXAMS = 'exams',
    TEAMS = 'teams',
    TEACHER_TRAINING_COURSES = 'teacher_training_courses',
    TEACHER_RESERVE = 'teacher_reserve',
    PORTFOLIO = 'portfolio',
    LIVE_EVENTS = 'live_events',
}

export enum TEACHER_HELP_MENU_ITEMS {
    HOW_TO_START = 'how_to_start',
    TELL_PARENT = 'tell_parent',
    TEACHER_HELP = 'teacher_help',
    SUPPORT = 'support',
    CALL_ME_BACK = 'call_me_back',
    SUPPORT_PHONE = 'support_phone',
    WEBINAR_INVITATION = 'webinar_invitation',
    SUPPORT_CHAT = 'support_chat',
}

export type TEACHER_HEADER_MENU_ITEMS =
    TEACHER_COMMON_MENU_ITEMS | TEACHER_HELP_MENU_ITEMS;
